export class Application {
  jobId: number;
  applicantId: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  resumeLocation: string;
  employeeReferral: string;
  coverLetterLocation: string;
  sessionId: string;
  sourceId: number;
  token: string;
}
